module.exports = __webpack_public_path__ + "packs/media/images/covid/covid-bc1d5227a6f96e66c6cd5abb8a73f1e9.png";